import {
	observer
} from 'mobx-react';
import {
	WeaTableNew
} from 'comsMobx';
import {
	WeaInputNumber
} from 'ecCom';
const WeaTable = WeaTableNew.WeaTable;

@observer
export default class Table extends React.Component {
	constructor(props) {
		super(props);
	}

	reRenderColumns = (columns, store) => {
		const {
			onDsporderChange
		} = store;

		columns.map(c => {
			if (c.dataIndex === 'dsporder') {
				c.render = function(text, record) {
					const {
						randomFieldId,
						dsporder,
					} = record;

					return (
						<WeaInputNumber
				            defaultValue = {dsporder}
				            onChange = {val => onDsporderChange(val,randomFieldId)}
          				/>
					)
				}
			}
		});
	}

	onOperatesClick = (record, rIndex, operate, store) => {
		const {
			randomFieldId
		} = record, {
			index
		} = operate;

		const {
			del,
		} = store;

		if (index === '0') {
			del(randomFieldId);
		}
	}

	render() {
		const {
			store
		} = this.props, {
			TABLE,
			table
		} = store;

		return (
			<WeaTable 
				{...TABLE}
				{...table}
				scroll={{y:300}}
				getColumns={columns => this.reRenderColumns(columns,store)}
				onOperatesClick={(record, index, operate) => this.onOperatesClick(record,index, operate,store)}
			/>
		);
	}
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/group/Table.js